import { render, staticRenderFns } from "./PopQuiz.vue?vue&type=template&id=3cb64d09"
import script from "./PopQuiz.vue?vue&type=script&lang=js"
export * from "./PopQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports